<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CardVS :cardContent="content" @updateUser="updateUser" />
    </template>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import CardVS from './components/CardVS.vue';
import '../../../assets/scss/_chineseStyle.scss';
import '../../../assets/scss/_chineseModalCustom.scss';
import LoadingMDL from '../../../components/loading/LoadingMDL';
export default {
  components: {CardVS, LoadingMDL},
  name: 'LKT04',
  data() {
    return {
      code: '',
      lang: '',
      content: {},
      CheckWidth: window.innerWidth.toString(),
      courseCode: '',
      courseId: '',
      courseSection: '',
      startTime: '',
      condition: [],
      loading: true,
    };
  },
  computed: {
    ...mapGetters({
      // allCourse: 'template/getTemplateContent',
      // getUserTemplate: 'template/getUserTemplate',
      getTemplatev3: 'v3/getTemplates',
    }),
  },
  watch: {
    getTemplatev3: function (val) {
      if (!val) return;

      this.v3Data = val;
      this.content = val.templates[0];
      this.navigate = this.content.navigate;

      if (!this.content.enable) {
        const pathFormat = this.content.navigate.close.action.split('-');
        alert('Access denied!');
        this.$router.push(`/v3/${pathFormat[0]}/${pathFormat[1]}`);
      }
      // this.$store.dispatch('v3/v3FilterParent', val.codeItem);

      this.loading = false;
    },
    // allCourse: function (val) {
    //   if (!val.enable) {
    //     alert('Access denied!');
    //     this.$router.push({name: val.navigate.close.action});
    //   } else {
    //     this.content = val;
    //     this.courseSection =
    //       this.$store.getters['necessary/getUserCourseSection'];
    //     this.$store.dispatch('template/createUserTemplateData', {
    //       code: this.courseId,
    //       template: val._id,
    //       section: this.courseSection,
    //     });
    //   }
    // },
    // getUserTemplate: function (val) {
    //   this.condition =
    //     typeof val.data.condition.criteriaType == 'undefined' ||
    //     val.data.condition.criteriaType.length == 0
    //       ? []
    //       : [
    //           {
    //             criteria: val.data.condition.criteriaType[0].criteria._id,
    //             val: val.data.condition.criteriaType[0].val,
    //           },
    //         ];
    //   this.loading = false;
    // },
  },

  mounted() {
    // let body = {};
    // body.code = this.courseId;
    // body.templateCode = 'LKT04-' + this.$route.params.id;
    // this.$store.dispatch('template/fetchContent', body);
    // this.$store.dispatch("courses/fetchCourseTopic", this.courseCode);
    this.onLoad();
  },
  created() {},
  beforeDestroy() {},
  methods: {
    onLoad() {
      this.lang = this.$store.state.language.language;
      this.courseCode = this.$store.getters['necessary/getLerningCourse'].code;
      this.courseId = this.$store.state.necessary.learningCourse;
      this.startTime = this.$helpers.getDateFormat();

      const contentId = `LKT04-${this.$route.params.id}`;
      this.$store.dispatch('v3/fetchTemplateByCode', contentId);
    },
    checkWidth() {
      if (this.CheckWidth > 800) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 800) {
        return 'container-chinese-card-mobile';
      }
    },
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    updateUser(path) {
      // this.$store.dispatch('template/saveUserTemplateData', {
      //   code: this.courseId,
      //   template: this.content._id,
      //   section:
      //     this.$store.getters['necessary/getLerningCourse'].groups[0].code,
      //   startTime: this.startTime,
      //   endTime: this.$helpers.getDateFormat(),
      //   condition: this.condition,
      // });

      const data = [
        {
          codeItem: this.v3Data.codeItem,
          courseId: this.$store.state.necessary.learningCourse,
          template: this.v3Data.templateID,
          section: this.$store.state.v3.v3EnrollData.data.section,
          content: this.v3Data.content,
          type: this.v3Data.type,
          answering: [],
          progress: 100,
          score: 0,
          maxScore: 0,
        },
      ];
      this.$store.dispatch('v3/saveContent', data);

      const str = path.split('-');
      const nextPath = `/v3/${str[0]}/${str[1]}`;
      this.$router.push(nextPath);
    },
  },
};
</script>
<style></style>
